<dashboardnav>
  <cradua-pole [poles]="poles$ | async" (pole)="onSubmitPole($event)" (deletePoleEvent)="onDeletePole($event)"
    *ngIf="(isLoadingPole$ | async ) === false">
  </cradua-pole>

  <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingPole$ | async) === true">
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
